import env from './config/env';

export function getAcadYears() {
  const { acadYear } = env;
  const beginYear = 2019;
  const arr = [];
  for (let i = beginYear; i <= acadYear; i += 1) {
    arr.push(i.toString());
  }
  return arr.reverse();
}
